/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptiontranslateforme4Inputs */

const en_eventdescriptiontranslateforme4 = /** @type {(inputs: Eventdescriptiontranslateforme4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate for me`)
};

const de_eventdescriptiontranslateforme4 = /** @type {(inputs: Eventdescriptiontranslateforme4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzen lassen`)
};

/**
* | output |
* | --- |
* | "Translate for me" |
*
* @param {Eventdescriptiontranslateforme4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptiontranslateforme4 = /** @type {((inputs?: Eventdescriptiontranslateforme4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptiontranslateforme4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptiontranslateforme4(inputs)
	return de_eventdescriptiontranslateforme4(inputs)
});
export { eventdescriptiontranslateforme4 as "eventDescriptionTranslateForMe" }